import { Checkbox } from 'primitives/checkbox'
import { Input, PasswordInput } from 'primitives/input'
import { RadioGroupComponent } from 'primitives/radio-group'
import { Select } from 'primitives/select'
import { SelectWithGroups } from 'primitives/select-with-groups'
import { Switch } from 'primitives/switch'
import { Textarea } from 'primitives/textarea'
import { SelectWithTabs } from '../select-with-tabs'

export const componentTypeMap = {
  input: {
    component: Input,
    extractValue: (e: React.ChangeEvent<HTMLInputElement>) => e.target.value,
  },
  inputPassword: {
    component: PasswordInput,
    extractValue: (e: React.ChangeEvent<HTMLInputElement>) => e.target.value,
  },
  inputNumber: {
    component: Input,
    extractValue: (e: React.ChangeEvent<HTMLInputElement>) =>
      Number.isNaN(parseInt(e.target.value, 10)) ? null : parseInt(e.target.value, 10),
  },
  selectWithGroups: {
    component: SelectWithGroups,
    extractValue: (e: string) => e,
  },
  select: {
    component: Select,
    extractValue: (e: string) => e,
  },
  selectWithTabs: {
    component: SelectWithTabs,
    extractValue: (e: string | string[]) => e,
  },
  checkbox: {
    component: Checkbox,
    extractValue: (e: boolean) => e,
  },
  switch: {
    component: Switch,
    extractValue: (e: boolean) => e,
  },
  textarea: {
    component: Textarea,
    extractValue: (e: React.ChangeEvent<HTMLInputElement>) => e.target.value,
  },
  radioGroup: {
    component: RadioGroupComponent,
    extractValue: (e: string | boolean) => e,
  },
}
